export enum ValueSource {
  casesParams = 'casesParams',
  presetValue = 'presetValue',
}

export enum ChangeType {
  add = 'add',
}

export interface PayloadAddPropFromCasesParams {
  valueSource: ValueSource.casesParams;
  changeType: ChangeType.add;
}

export interface PayloadAddPropFromPresetValue {
  valueSource: ValueSource.presetValue;
  changeType: ChangeType.add;
  presetValue: string; // The preset value to use, encoded as a string
}

export interface PayloadTransforms {
  [key: string]: PayloadAddPropFromCasesParams | PayloadAddPropFromPresetValue;
}

export interface NotificationServiceSupportedMetadata {
  description?: string;
  secondaryAnalysisPayloadTransforms: {
    description?: string;
    payloadTransforms: PayloadTransforms;
  };
}

export interface NotificationService {
  id: string;
  arn: string;
  metadata: NotificationServiceSupportedMetadata;
  createdAt: string;
}
